import { render, staticRenderFns } from "./LevelForm.vue?vue&type=template&id=18434890&scoped=true&"
import script from "./LevelForm.vue?vue&type=script&lang=js&"
export * from "./LevelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18434890",
  null
  
)

export default component.exports